<template>
  <div class="order-selector">
    <v-autocomplete
      :value="selected"
      @input="select"
      :items="data"
      :label="lang.orders.title_s"
      :filter="filter"
      :no-data-text="lang.orders.datatable.no_results"
      item-value="id"
      :clearable="clearable"
      :single-line="singleLine"
      clear-icon="mdi-broom"
      prepend-inner-icon="mdi-view-list"
      attach=".orders-autocomplete"
      :menu-props="{ maxHeight: 250 }"
      class="orders-autocomplete"
      autocomplete="off"
      filled
      hide-chips
      hide-details
    >
      <template v-slot:selection="{}">
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>
            <MiniTable
              :value="item"
            />
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    <template v-if="selected > 0 && selected !== false">
      <div class="py-0 px-2">
        <MiniTable
          :value="getOrder(selected)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import MiniTable from './MiniTable'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import orders from '@/components/orders/mixins/index'

export default {
  components: { MiniTable },
  mixins: [ appdata, utils, orders ],
  props: {
    value: {
      type: Number,
      default: -1
    },
    multiple: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    singleLine: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: (this.value ? this.value : -1)
    }
  },
  computed: {
    data () {
      let orders = this.get_data.orders || []
      return orders
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.value) !== JSON.stringify(newVal)) this.$emit('input', this.selected || -1)
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal)) this.selected = this.value
      }
    }
  },
  methods: {
    filter (item, queryText) {
      if (item && queryText) {
        let data = JSON.stringify(item)
        // return Object.values(item).some((val) => val.includes(queryText))
        return (data.toLowerCase().trim().search(queryText.toLowerCase()) > -1)
      }
      return false
    },
    select (std) {
      this.$set(this, 'selected', std)
    },
    remove (item) {
      const obj = (this.returnObject ? this.selected.find(el => el.id === item.id) : this.selected.find(el => el === item.id))
      const index = this.selected.indexOf(obj)
      if (index >= 0) this.selected.splice(index, 1)
    }
  }
}
</script>

<style scoped src="../styles/autocomplete.scss" lang="scss"></style>
<style lang="scss">
.order-selector {
  #app & {
    border-radius: 7px;
    .orders-autocomplete {
      .v-list-item {
        max-height: 70px !important;
      } 
    }
  }

  #app.theme--light & {
    background: rgba(0, 0, 0, 0.03);
    .orders-autocomplete {
      .v-list-item {
        border-bottom: 2px dashed #ddd;
      } 
    }
  }

  #app.theme--dark & {
    background: rgba(255, 255, 255, 0.1);
    .orders-autocomplete {
      .v-list-item {
        border-bottom: 2px dashed #555;
      } 
    }
  }
}
</style>
